import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

interface EntityTab {
  value: string;
  label: string;
  content: React.ReactNode;
}

interface EntityDetailsShellProps {
  selected: boolean;
  selectedTitle?: string;
  emptyTitle?: string;
  emptyDescription?: string;
  tabs: EntityTab[];
  activeTab: string;
  onTabChange: (value: string) => void;
  headerActions?: React.ReactNode;
}

export function EntityDetailsShell({
  selected,
  selectedTitle,
  emptyTitle = "Выберите запись",
  emptyDescription = "Выберите элемент в списке слева.",
  tabs,
  activeTab,
  onTabChange,
  headerActions,
}: EntityDetailsShellProps) {
  if (!selected) {
    return (
      <Card className="max-w-2xl">
        <CardHeader>
          <CardTitle>{emptyTitle}</CardTitle>
        </CardHeader>
        <CardContent className="text-sm text-muted-foreground">{emptyDescription}</CardContent>
      </Card>
    );
  }

  return (
    <div className="min-w-0 space-y-4">
      {selectedTitle || headerActions ? (
        <div className="flex flex-wrap items-center justify-between gap-2">
          {selectedTitle ? (
            <div className="min-w-0 text-sm text-muted-foreground">
              Текущая запись: <span className="font-medium text-foreground">{selectedTitle}</span>
            </div>
          ) : (
            <div />
          )}
          {headerActions ? <div className="flex flex-wrap items-center gap-2">{headerActions}</div> : null}
        </div>
      ) : null}
      <Tabs value={activeTab} onValueChange={onTabChange} className="min-w-0">
        <TabsList className="h-auto w-full flex flex-wrap justify-start gap-1">
          {tabs.map((tab) => (
            <TabsTrigger key={tab.value} value={tab.value} className="shrink-0">
              {tab.label}
            </TabsTrigger>
          ))}
        </TabsList>
        {tabs.map((tab) => (
          <TabsContent key={tab.value} value={tab.value} className="min-w-0">
            {tab.content}
          </TabsContent>
        ))}
      </Tabs>
    </div>
  );
}

